<template>
  <custom-callout :has-toggle="true" :show-edition="expanded" :border-color="leftColor">
    <div class="mx-auto row">
      <div class="col-xs-12 col-sm-3 col-md-3 with-border px-lc-4">
        <em
          v-if="hasIconExpand"
          class="fa fsi chevron-mobile d-lc-inline"
          :class="{
            'fa-chevron-circle-right': !expanded,
            'fa-chevron-circle-down text-green': expanded
          }"
          @click="expanded = !expanded"
        />
        <custom-balloon
          class="d-lc-inline"
          :text="statusName"
          :background-color="leftColor"
        />

        <slot name="status_bottom" />

        <div v-if="hasIconExpand" class="col-12 chevron pl-1">
          <em
            class="fa fsi"
            :class="{
              'fa-chevron-circle-right': !expanded,
              'fa-chevron-circle-down text-green': expanded
            }"
            @click="expanded = !expanded"
          />
        </div>
      </div>
      <div :class="customBoardInformationClass">
        <slot :name="`board_information`" />
      </div>
      <div
        v-if="actions.length > 0"
        :class="customActionsClass"
      >
        <drop-down
          class="mt-3"
          :class="haveCheck ? 'check-padding-right' : ''"
          :items="actions"
          hide-without-items
          @option="item => $emit('action', item)"
        />
        <div v-if="haveCheck" class="d-flex align-items-center with-left-border check-padding-left">
          <check-box
            v-model="isSelected"
            :value="isSelected"
            :disabled="false"
            name="studentFactors"
          />
        </div>
      </div>
    </div>
    <div class="clearfix" />
    <template #edition>
      <slot name="board_details" />
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from "@/components/common/CustomCallout";
import CustomBalloon from "@/components/common/CustomBalloon";
import DropDown from "@/components/common/menu/DropDown";
import CheckBox from "CheckBox";
export default {
  name: "CustomResults",
  components: {
    CustomCallout,
    CustomBalloon,
    DropDown,
    CheckBox
  },
  data() {
    return {
      expanded: this.isOpen,
      isSelected: this.checkVal
    };
  },
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    haveCheck: {
      type: Boolean,
      default: () => false
    },
    checkVal: {
      type: Boolean,
      default: () => false
    },
    isOpen: {
      type: Boolean,
      default: () => false
    },
    leftColor: {
      type: String,
      default: () => ""
    },
    statusName: {
      type: String,
      default: () => ""
    },
    cols: {
      type: Number,
      required: true
    },
    rows: {
      type: Number,
      required: true
    },
    hasIconExpand: {
      type: Boolean,
      default: () => true
    },
    customBoardInformationClass: {
      type: String,
      default: () => "col-xs-12 col-sm-6 col-md-7"
    },
    customActionsClass: {
      type: String,
      default: () => "col-xs-12 col-sm-3 col-md-3 actions d-flex justify-content-end"
    }
  },
  watch: {
    isOpen(nw) {
      this.expanded = nw;
    },
    isSelected(nw) {
      this.$emit('chekValue', nw)
    }
  }
};
</script>

<style scoped>
.flex--direction {
  flex-direction: row;
}

.board:nth-child(2) {
  border-left: 1px solid #dee2e6;
  padding-left: 2%;
}

.board {
  margin-right: 25px;
}

.bag {
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  padding: 10px 30px;
}

.fsi {
  font-size: 26px;
  color: #3f5b60;
  cursor: pointer;
}

.chevron-mobile {
  display: none;
}

.with-border {
  border-right: 1px solid #c3c3c3;
}

.px-lc-5 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.check-padding-right {
  padding-right: 7%;
}
.check-padding-left {
  padding-left: 7%;
}

@media screen and (max-width: 1050px) {
  .px-lc-5 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
}

@media screen and (max-width: 576px) {
  .actions {
    margin-left: 2rem;
  }
}

@media screen and (max-width: 650px) {
  .flex--direction {
    flex-direction: column;
  }

  .board {
    flex-basis: 0;
  }

  .board:nth-child(2) {
    border-left: none;
    padding-left: 0;
  }

  .chevron-mobile {
    position: relative;
    top: 2px;
  }

  .chevron {
    display: none;
  }

  .d-lc-inline {
    display: inline !important;
  }

  .with-border {
    border-right: none;
  }
}
.with-left-border {
  border-left: solid 1px #c3c3c3;
}
</style>
